
<template>
  <div class="page-container">
    <div class="section">
      <div class="control-box control-box-width">
        <div class="left" style="width: 80%;">
          <el-button class="control-item" icon="el-icon-back" @click="goBack">
            {{ $t('return') }}
          </el-button>
          <el-date-picker
            class="item-component"
            v-model="query.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('select_start_date')"
            :picker-options="pickerOptionsStart"
            @change="startTimeChange"
          >
          </el-date-picker>
          <el-date-picker
            class="item-component ml10"
            v-model="query.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('select_end_date')"
            :picker-options="pickerOptionsEnd"
            @change="endTimeChange"
          >
          </el-date-picker>
          <el-select
            style="width: 250px"
            class="item-component-select ml10"
            v-model="equipment"
            clearable
            :placeholder="$t('xuanzeDevice')"
            filterable
          >
            <el-option
              v-for="item in tableNumber"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-select
              style="width: 250px"
              class="item-component-select ml10"
              v-model="query.type"
              clearable
              :placeholder="$t('please_select_device_type')"
              filterable
          >
            <el-option
                v-for="(item, index) in deviceList"
                :key="index"
                :label="item.text"
                :value="item.value"
            />
          </el-select>
        </div>
        <div class="cb-right right-center">
          <el-button
            type="primary"
            @click="handleExport"
          >
            {{ $t('export') }}
          </el-button>
          <el-button
            type="primary"
            @click="handelQueryCheck"
          >
            {{ $t('query') }}
          </el-button>
        </div>
      </div>
      <div class="content" style="padding: 0 0 0 20px">
        <div class="table-box" >
          <el-table
            :data="maintainData"
            border
            style="width: 100%;"
          >
            <el-table-column
              prop="personName"
              :label="$t('reporter')"
              align="left"
            ></el-table-column>
            <el-table-column
              prop="repairInfo"
              :label="$t('fault_description')"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="repairTime"
              :label="$t('submit_time')"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('maintenance_person')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="startDate"
              :label="$t('startTime')"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="date"
              :label="$t('endTime')"
              align="left"
            ></el-table-column>
            <el-table-column
              prop="time"
              :label="$t('Time_taken')"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="price"
              :label="$t('cost')"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="info"
              :label="$t('Maintenance_Summary')"
              align="center"
            ></el-table-column>
            <el-table-column
                prop="deviceName"
                :label="$t('deviceName')"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="confirmUser"
                :label="$t('Acceptance_Person')"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="confirmInfo"
                :label="$t('acceptance_results')"
                align="center"
            ></el-table-column>
            <el-table-column
                prop="remark"
                :label="$t('Acceptance_Remarks')"
                align="center"
            ></el-table-column>
            <el-table-column
              prop="state"
              :label="$t('device_state')"
              align="center"
            >
              <template slot-scope="{ row }">
                <span v-if="!isChineseLocale">{{row.state}}</span>
                <span v-if="isChineseLocale">{{ row.stateNum === '0' ? $t('assigned') : row.stateNum === '1' ? $t('pending_start') : row.stateNum === '2' ? $t('in_progress') : row.stateNum === '3' ? $t('pending_confirmation') : row.stateNum === '4' ? $t('completed') : row.stateNum === '5' ? $t('cancelled') : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="state"
                :label="$t('caozuo')"
                align="center"
            >
              <template slot-scope="{ row }">
                <el-button v-if="row.state === '已完成' && row.confirmInfo === '已修复'" type="primary" size="mini" @click.stop="handleExportDetail(row.id)">
                  {{ $t('Export_repair_order') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-box">
            <el-pagination
              v-show="totalCount>0"
              :current-page="query.page"
              :page-sizes="[10, 20, 30, 40]"
              :total="totalCount"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import API from '@/api';
export default {
  name: "maintenanceDetail",
  data() {
    return {
      maintainData: [],
      tableNumber: [],
      filter: {
        startTime: undefined,
        endTime: undefined,
        teamId: '',
        count: 10,
        page: 1,
        name: '',
        totalCount: 0
      },
      deviceList: [
        {
          value: -1,
          text: this.$t('all')
        },
        {
          value: 1,
          text: this.$t('yinqian_device')
        },
        {
          value: 2,
          text: this.$t('yinshua_device')
        },
        {
          value: 3,
          text: this.$t('yinhou_device')
        }
      ],
      query: {
        startTime: undefined,
        endTime: undefined,
        count: 10,
        page: 1,
        type:-1,
        teamId: '',
        // sheetType: this.selectedSheetType,
      },
      totalCount: 0,
      equipment: '',
      equipmentDown: '',
      startTime: undefined,
      endTime: undefined,
      pickerOptionsStart:{
        disabledDate: time => {
          if (this.query.endTime) {
            return (
              time.getTime() > new Date(this.query.endTime).getTime() || time.getTime() < new Date(this.query.endTime).getTime() - 100 * 24 * 3600000 || time.getTime(new Date()) > Date.now()
            );
          }else{
            return time.getTime(new Date()) > Date.now();
          }
        }
      },
      pickerOptionsEnd:{
        disabledDate: time => {
          if (this.query.startTime) {
            return (
              time.getTime() < new Date(this.query.startTime).getTime() - 8.64e7 || time.getTime() > new Date(this.query.startTime).getTime() + 100 * 24 * 3600000 || time.getTime(new Date()) > Date.now()
            );
          }else{
            return time.getTime(new Date()) > Date.now();
          }
        }
      },

    };
  },
  mounted() {

  },
  computed: {
    isChineseLocale() {
      return localStorage.getItem('locale') === 'en';
    }
  },
  created() {
    console.log(this.$route.query)
    this.query.startTime = this.$route.query.startTime
    this.query.endTime = this.$route.query.endTime
    this.query.teamId = this.$route.query.teamId
    this.startTime = this.$route.query.startTime
    this.endTime = this.$route.query.endTime
    this.getList()
  },
  methods: {
    getList() {
      API.deviceListWeixiu({teamId: this.$route.query.teamId,...this.query}).then((response) => {
        this.tableNumber = response.message.data;
        this.handelQuery()
        // this.totalCount = response.totalCount;
      });
    },
    handelQueryCheck() {
      if (!this.query.startTime || !this.query.endTime) {
        this.$message.warning(this.$t('please_select_start_end_time'))
        return
      }
      this.query.page = 1
      this.query.count = 10
      this.handelQuery()
    },
    handelQuery() {
      // this.query.page = 1
      this.equipmentDown = this.equipment
      this.startTime = this.query.startTime
      this.endTime = this.query.endTime
      if (!this.query.type) {
        this.query.type = -1
      }
      API.detaileListWeixiu({...this.query,teamId: this.$route.query.teamId,deviceId: this.equipment}).then(res => {
        console.log(res)
        this.maintainData = res.message.data.list
        this.totalCount = res.message.data.totalCount
      })
    },
    handleSizeChange(val) {
      this.query.count = val;
      this.query.page = 1;
      this.handelQuery();
    },
    // 当前页数改变时会触发
    handleCurrentChange(val) {
      this.query.page = val;
      this.handelQuery();
    },
    startTimeChange(val){
      if(this.query.endTime && new Date(val).getTime() > new Date(this.query.endTime).getTime()){
        this.query.startTime = null
      }else{
        this.query.startTime = val
      }
    },
    endTimeChange(val){
      // 最长时间跨度100天
      if(this.query.startTime && new Date(val).getTime() - new Date(this.query.startTime).getTime() > 100 * 24 * 60 * 60 *1000){
        this.query.endTime = null
      }else{
        this.query.endTime = val
      }
    },
    handleExportDetail(id) {
      API.importRepair(id).then(res => {
        window.open(res.message.data)
      })
    },
    handleExport() {
      if (!this.query.startTime || !this.query.endTime) {
        this.$message.warning(this.$t('please_select_start_end_time'))
        return
      }
      require.ensure([], () => {
        const {export_json_to_excel} = require('@/views/ExcelLeadOut/Export2Excel'); // 注意这个Export2Excel路径
        const tHeader = [
          this.$t('reporter'),
          this.$t('fault_description'),
          this.$t('submit_time'),
          this.$t('maintenance_person'),
          this.$t('startTime'),
          this.$t('endTime'),
          '用时',
          this.$t('cost'),
          this.$t('Maintenance_Summary'),
          this.$t('device_add_name'),
          this.$t('Acceptance_Person'),
          this.$t('acceptance_results'),
          this.$t('Acceptance_Remarks'),
          this.$t('device_state'),
        ]; // 表格标题
        const filterVal = [
          'personName',
          'repairInfo',
          'repairTime',
          'name',
          'startDate',
          'date',
          'time',
          'price',
          'info',
          'deviceName',
          'confirmUser',
          'confirmInfo',
          'remark',
          'state'
        ]; // 标题属性key值
        if (!this.query.type) {
          this.query.type = -1
        }
        API.detaileListWeixiu({...this.query,startTime: this.startTime,endTime:this.endTime,deviceId: this.equipmentDown,count:100000,page:1}).then(res => {
          const list = res.message.data.list; // 把要导出的数据tableData存到list
          const data = this.formatJson(filterVal, list);
          export_json_to_excel(tHeader, data, this.$t('Repair_details')); // 最后一个是表名字
        })

      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped lang="scss">
.pagination-box {
  margin-top: 20px;
}
.control-item {
  margin-right: 15px;
}
.ml10{
  margin-left: 2%;
}
</style>
